module.exports = "/img/_/_/_/assets/images/creeper/battle/common//1.jpg?586c0f4273ea30297335bc8b3d48d187";